export default __webpack_public_path__ + "static/media/naturevshumanLogo.6e81405b.png";